<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-click-outside="closeModal">
          <div class="modal-header">
            <slot name="header"></slot>
          </div>
          <div class="modal-body text-center">
            <md-content class="md-scrollbar">
              <form id="item_form">
                <div class="md-layout">
                  <label class="md-layout-item md-size-35 md-form-label">Nombre de Insumo</label>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <md-input
                        v-model="updatedItem.name"
                        type="text"
                        name="updatedItem.name"
                        disabled
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <label class="md-layout-item md-size-35 md-form-label">Código de Insumo</label>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <md-input
                        v-model="updatedItem.code"
                        type="text"
                        name="updatedItem.code"
                        disabled
                      ></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <label class="md-layout-item md-size-35 md-form-label">Código SCT</label>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <md-input
                        v-model="updatedItem.sctCode"
                        type="text"
                        name="updatedItem.code"
                        disabled
                      ></md-input>
                      <span class="md-helper-text">Código SCT</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-35">
                    <label for="updatedItem.isDivisible">¿Es divisible?</label>
                  </div>
                  <div class="md-layout-item md-size-65">
                    <md-switch v-model="updatedItem.isDivisible" disabled></md-switch>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-35">
                    <label class="md-form-label">Unidad de Medida</label>
                  </div>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <label for="updatedItem.unitMeasurement">Unidad de Medida</label>
                      <!-- UM{{updatedItem}} -->
                      <md-select
                        v-model="updatedItem.unitMeasurementId"
                        name="updatedItem.unitMeasurement"
                        id="updatedItem.unitMeasurement"
                        disabled
                      >
                        <md-option
                          :value="c.id"
                          v-for="c in mMeass"
                          :key="c.id"
                          required
                        >{{ c.name }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-35">
                    <label class="md-form-label">Tipo de Insumo</label>
                  </div>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <label for="updatedItem.supplyType">Tipo de Insumo</label>
                      <md-select
                        v-model="updatedItem.supplyTypeId"
                        name="updatedItem.supplyType"
                        id="updatedItem.supplyType"
                        disabled
                      >
                        <md-option :value="c.id" v-for="c in mSupplyType" :key="c.id">{{ c.name }}</md-option>
                      </md-select>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <label class="md-layout-item md-size-35 md-form-label">Peso Volumétrico</label>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <md-input
                        type="number"
                        name="updatedItem.unitWeight"
                        v-model="updatedItem.unitWeight"
                        disabled
                      ></md-input>
                      <span class="md-suffix">Kg</span>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <label class="md-layout-item md-size-35 md-form-label">Comentario sobre Insumo</label>
                  <div class="md-layout-item md-size-65">
                    <md-field>
                      <md-textarea v-model="updatedItem.comment" disabled></md-textarea>
                    </md-field>
                  </div>
                </div>
              </form>
            </md-content>
          </div>

          <div class="modal-footer">
            <md-button class="md-info md-round" type="submit" @click="closeModal">listo</md-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import dataService from "@/services/catalog";

export default {
  components: {},

  props: {
    editedItem: Object,
  },

  data() {
    return {
      updatedItem: {},
      mMeass: [],
      mSupplyType: [],
    };
  },

  methods: {
    closeModal: function () {
      this.$emit("close");
    },

    consultMetas(ruta, asign, arg1, arg2) {
      // Make query for metaDatas
      let configuret;

      if (arg2) {
        configuret = {
          id: arg1,
          extraId: arg2,
          noStore: true,
          collection: true,
        };
      } else {
        configuret = { id: arg1, noStore: true };
      }
      dataService.fetch(ruta, configuret).then((res) => {
        this[asign] = res;
      });
    },
  },

  mounted() {
    this.updatedItem = { ...this.editedItem };
    this.consultMetas("common/unit_measurement", "mMeass");
    this.consultMetas("services/supplytype", "mSupplyType");
  },
  computed: {
    ...mapState("catalogs", {
      families: (s) => s["services/families"],
    }),
  },
};
</script>

<style lang="scss" scoped>
.md-content {
  max-width: 100%;
  max-height: 500px;
  overflow: auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/showSupply.vue